import { Typography } from '@vp/swan'
import { useTranslation } from 'react-i18next'

interface LastModifiedDateProps {
  lastModifiedDate?: string
  locale?: string
  tenant?: string
}

export const LastModifiedDate = ({ lastModifiedDate, locale, tenant = 'vistaprint' }: LastModifiedDateProps) => {
  const { t } = useTranslation(tenant)

  if (!lastModifiedDate) return null

  const lng = locale?.toLowerCase()?.replace('-', '_') || 'en_us'

  const formatDate = (dateString: string, locale: string = 'en-US'): string => {
    try {
      // Parse the ISO date string
      const date = new Date(dateString)

      // Format the date to "Month DD, YYYY" format
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }

      const formattedLocale = locale?.replace('_', '-') || 'en-US'

      return date.toLocaleDateString(formattedLocale, options)
    } catch (error) {
      console.warn('Error formatting date:', error)
      return dateString
    }
  }

  return (
    <Typography fontSkin="body-small" textColor="subtle">
      {t(`${tenant}:articles.last_updated`, { lng })} {formatDate(lastModifiedDate, locale)}
    </Typography>
  )
}
